// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"bda156cf","84":"a51d4e30","127":"607b9295","179":"78a25a56","199":"a5b5655b","204":"31866e1b","331":"ac76d657","415":"b95fbd8b","533":"7d04dfe3","567":"ec9a5b86","683":"5f418a4c","750":"616d4f59","820":"bdbf0556","886":"8d20ba2d"}[chunkId] + ".chunk.js";
};